import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        schoolId: 0,
        searchContent: '',
        list:{},// 用于存储录取概率里面的省份
        school_list: JSON.parse(sessionStorage.getItem('school_list')) ? JSON.parse(sessionStorage.getItem('school_list')) : [], //用于录取概率存储添加对比学校信息   
        deleteSch: [], //用于录取概率删除添加对比学校信息
        num:0,
        volunteer_list:[],//生成志愿表的数据
        userInfo: JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')) : {},
        iphone:0,
        areaInfo: {
            "province": "安徽省", 
            "pid": 14234,
            "city": "合肥市",
            "cid": '14235'
        },
        type: {
            institution_type: '',
            labe_id: '',
            institution_name: '院校类型',
            disciplinary_level: '',
            disciplinary_name: '批次',  //1,一本，2，二本，4，专科
        }
    },
    mutations: {
        LOGIN(state, value) {
            state.userInfo = value;
            localStorage.setItem('userInfo', JSON.stringify(value));
        }
    },
    actions: {

    }
})
